import React, { useState, useEffect } from 'react'
import { Form, Upload, Result, Button } from 'antd'
import { InboxOutlined } from '@ant-design/icons'
import { csv } from 'csvtojson'
import { func } from 'prop-types'

import { camelize, normalize } from '@utils/textUtils'
import { useCreateFertilizer } from '@graphql/mutations'

const options = {
  trim: true,
  ignoreEmpty: true,
  delimiter: ';',
}

function ManageFertilizerCsvUpload({ afterSubmit }) {
  const [data, setData] = useState()
  const [uploadComplete, setUploadComplete] = useState(false)
  const [createFertilizer, { loading }] = useCreateFertilizer()

  const normFile = e => {
    if (Array.isArray(e)) return e

    return e && e.fileList
  }

  useEffect(() => {
    const createAllFertilizers = data => {
      data.map(async d => {
        const { nomeComercial, unidadesN, unidadesP, unidadesK } = d

        await createFertilizer({
          variables: {
            data: {
              name: nomeComercial,
              n: parseFloat(unidadesN),
              p: parseFloat(unidadesP),
              k: parseFloat(unidadesK),
            },
          },
          refetchQueries: ['GetFertilizersQuery'],
        })
      })

      setUploadComplete(true)
    }

    if (data) createAllFertilizers(data)
  }, [data, createFertilizer])

  const handleUpload = () => {}
  const props = {
    accept: `.txt, .csv, .xlsx`,
    name: `files`,
    beforeUpload: file => {
      const reader = new FileReader()

      reader.onload = e => {
        // const parsed = Papa.parse(e.target.result)

        csv(options)
          .fromString(e.target.result)
          .preFileLine((fileLineString, lineIdx) => {
            if (lineIdx === 0) {
              return normalize(
                camelize(fileLineString.toLowerCase()),
              )
            }

            return fileLineString
          })
          .then(data => setData(data))
      }

      reader.readAsText(file)

      return false
    },
  }

  if (uploadComplete) {
    return (
      <Result
        status="success"
        title="Fertilizantes importados"
        subTitle="Pode fechar esta caixa."
        extra={[
          <Button type="primary" key="close" onClick={() => afterSubmit()}>
            Fechar
          </Button>,
        ]}
      />
    )
  }

  return (
    <Form onFinish={handleUpload}>
      <Form.Item>
        {!loading ? (
          <Form.Item name="dragger" valuePropName="fileList" getValueFromEvent={normFile} noStyle>
            <Upload.Dragger {...props}>
              <p className="ant-upload-drag-icon">
                <InboxOutlined />
              </p>
              <p className="ant-upload-text">
                Clique ou arraste uma ficheiro para efectuar o upload.
              </p>
            </Upload.Dragger>
          </Form.Item>
        ) : `Loading ...`}
      </Form.Item>
    </Form>
  )
}

ManageFertilizerCsvUpload.propTypes = {
  afterSubmit: func.isRequired,
}

export default ManageFertilizerCsvUpload
